/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum UserPinType {
	Form = 'Form',
	EntryView = 'EntryView',
	Folder = 'Folder',
}
